import { Box, Button, Stack } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { layoutStyle } from "../layout-ui/style";
import { SearchBar } from "../../components/SearchBar";
import { HelpDeskDataColumn } from "../../common/constants/gridRowColumn";
import { AgGridReact } from "ag-grid-react";
import AddHelpDesk from "./AddHelpDesk";
import { useHelpDesk } from "../../common/hooks";
import { TruckLoader } from "./truckLoader";
import {
  actionColumnFunction,
  getDefaultColDef,
  isAdmin,
} from "../../common/constants/commonFunction";
import { useNavigate } from "react-router-dom";

export const HelpDeskDealer = () => {
  const classes = layoutStyle();
  const [open, setOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [columnFinal, setColumnFinal] = useState([]);
  const [refreshData, setRefreshData] = useState(false);
  const [rowData, setRowData] = useState([]);
  const { getHelpDeskListApi, helpdeskList, loading } = useHelpDesk();
  const navigation = useNavigate();
  const defaultColDef = useMemo(() => getDefaultColDef(), []);

  const handleCreateHelp = (params) => {
    setOpen(true);
  };
  useEffect(() => {
    getHelpDeskListApi({
      limit: 10000,
      offset: 0,
      filter: {
        userId: parseInt(localStorage.getItem("cashflow_admin_user_id")),
      },
    });
  }, []);
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (helpdeskList?.length > 0) {
      setRowData(helpdeskList);
    } else {
      setRowData([]);
    }
  }, [helpdeskList]);

  const handleEditButton = (params) => {
    // setOpen(true);
    navigation("/user-queries", { state: params });
    // setParamsValue(params);
  };

  useEffect(() => {
    if (HelpDeskDataColumn?.length > 0) {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        deleteButton: isAdmin(),
        viewButton: true,
      });
      setColumnFinal([...HelpDeskDataColumn, actionColumn]);
    }
  }, [HelpDeskDataColumn]);
  return (
    <Box className={classes.mainContent}>
      <Box className={classes.gridContantFleetList}>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Box className={classes.headerNameText}>Help Desk</Box>
          <Box className={classes.addEditGrid}>
            <Button
              variant="outlined"
              className={classes.fleetListNewButton}
              onClick={handleCreateHelp}
            >
              Create
            </Button>
            <SearchBar />
          </Box>
        </Stack>
        <Box className={classes.helpDeskGridContant}>
          {loading ? (
            <TruckLoader />
          ) : (
            <AgGridReact
              className="ag-theme-quartz ag-grid-helpdesk"
              suppressRowClickSelection
              rowHeight={35}
              onSelectionChanged={(event) => {
                const selectedNodes = event?.api?.getSelectedNodes();
                const selectedRows = selectedNodes?.map((node) => node?.data);
                setSelectedRows(selectedRows);
              }}
              pagination={true}
              rowData={rowData}
              defaultColDef={defaultColDef}
              columnDefs={columnFinal}
            />
          )}
        </Box>
      </Box>
      {open && (
        <AddHelpDesk
          setRefreshData={setRefreshData}
          setOpen={setOpen}
          open={open}
          title={"Create Ticket"}
        />
      )}
    </Box>
  );
};
